import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import styles from './NoteNav.module.css'
import { AlButton, BlankButton, HEPButton } from '_components';

class PatientCareCenterNoteNav extends React.Component {


    hepClicked() {
        this.props.openHEP(this.props.epno);
    }

    render() {
        return (
            <div className={styles.wrapper}>
                <span className={styles.notenav}>
                    <BlankButton label='S' title='Subjective' className={styles.button} onClick={() => this.props.subjectiveRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
                    <BlankButton label='O' title='Objective' className={styles.button} onClick={() => this.props.objectiveRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
                    <AlButton className={styles.button} onClick={() => this.props.alRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
                    <BlankButton label='G' title='Goals' className={styles.button} onClick={() => this.props.goalsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
                    <BlankButton label='A' title='Assessment' className={styles.button} onClick={() => this.props.assessmentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
                    <BlankButton label='P' title='Plan' className={styles.button} onClick={() => this.props.planRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
                    <BlankButton label='C' title='Charges' className={styles.button} onClick={() => this.props.chargesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
                </span>
                <span className={styles.otherbuttons}>
                    {this.props.hepEnabled &&
                        <HEPButton onClick={() => this.hepClicked()} />
                    }
                </span>
            </div>
        );
    }

}


function mapDispatchToProps(dispatch) {
    return {
        openHEP: bindActionCreators(patientActions.openHEP, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let hepEnabled = state.entities.masterData.PROPS['HEP-ENABLED'] && state.entities.masterData.PROPS['HEP-ENABLED'].PRVALUE === 'TRUE' ? true : false;

    return {
        epno,
        hepEnabled
    };
}

const connectedPatientCareCenterNoteNav = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteNav);
export { connectedPatientCareCenterNoteNav as PatientCareCenterNoteNav };

